import React from 'react'

const NoMatch = () => (
  <div className="row justify-content-center">
    <div className="col-12 col-md-10 col-lg-8  col-xl-6">
      <h1>Page not found</h1>
    </div>
  </div>
);

export default NoMatch;
